/* tslint:disable */
import {
  CompanyAccount,
  PropertyType
} from '../index';

declare var Object: any;
export interface PropertyPropertyTypeInterface {
  "id"?: number;
  "property_id"?: number;
  "property_type_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  companyAccount?: CompanyAccount;
  propertyType?: PropertyType;
}

export class PropertyPropertyType implements PropertyPropertyTypeInterface {
  "id": number;
  "property_id": number;
  "property_type_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  companyAccount: CompanyAccount;
  propertyType: PropertyType;
  constructor(data?: PropertyPropertyTypeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PropertyPropertyType`.
   */
  public static getModelName() {
    return "PropertyPropertyType";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PropertyPropertyType for dynamic purposes.
  **/
  public static factory(data: PropertyPropertyTypeInterface): PropertyPropertyType{
    return new PropertyPropertyType(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PropertyPropertyType',
      plural: 'PropertyPropertyTypes',
      path: 'PropertyPropertyTypes',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "property_type_id": {
          name: 'property_type_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        companyAccount: {
          name: 'companyAccount',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'property_id',
          keyTo: 'id'
        },
        propertyType: {
          name: 'propertyType',
          type: 'PropertyType',
          model: 'PropertyType',
          relationType: 'belongsTo',
                  keyFrom: 'property_type_id',
          keyTo: 'id'
        },
      }
    }
  }
}
